import AirDatepicker from 'air-datepicker'
import localeEn from 'air-datepicker/locale/en'
import subYears from 'date-fns/subYears'

const localeIs = {
  daysMin: ['Su', 'Má', 'Þr', 'Mi', 'Fi', 'Fö', 'La'],
  months: [
    'Janúar',
    'Febrúar',
    'Mars',
    'Apríl',
    'Maí',
    'Júní',
    'Júlí',
    'Ágúst',
    'September',
    'Október',
    'Nóvember',
    'Desember',
  ],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maí', 'Jún', 'Júl', 'Ágú', 'Sep', 'Okt', 'Nóv', 'Des'],
  today: 'Í dag',
  clear: 'Hreinsa',
  dateFormat: 'dd.MM.yyyy',
  timeFormat: 'hh:mm aa',
}

const DatepickerRange = {
  init: (target) => {
    const { lang } = document.documentElement
    let fromDate = null
    let toDate = null
    const fromDateEl = target.querySelector('[data-isFrom]')
    const toDateEl = target.querySelector('[data-isTo]')

    fromDate = new AirDatepicker(fromDateEl, {
      locale: lang === 'is' ? localeIs : localeEn,
      firstDay: 0,
      dateFormat: 'dd.MM.yyyy',
      startDate: subYears(new Date(), 1),
      selectedDates: [fromDateEl.value],
      maxDate: new Date(),
      onSelect({ date }) {
        toDate.update({
          minDate: date,
        })
        fromDate.hide()
      },
    })

    toDate = new AirDatepicker(toDateEl, {
      locale: lang === 'is' ? localeIs : localeEn,
      firstDay: 0,
      dateFormat: 'dd.MM.yyyy',
      startDate: new Date(),
      selectedDates: [toDateEl.value],
      minDate: subYears(new Date(), 1),
      onSelect({ date }) {
        fromDate.update({
          maxDate: date,
        })
        toDate.hide()
      },
    })
  },
}

export default DatepickerRange
